import { ComponentStyleConfig } from "@chakra-ui/react";

const ToastTheme: ComponentStyleConfig = {
  baseStyle: {
    container: {
      px: "24px",
      py: "16px",
      borderWidth: "1px",
      borderRadius: "8px",
      shadow: "lg",
      width: "440px",
    },
    message: {
      textStyle: "h5",
      textColor: "inherit",
      whiteSpace: "pre-wrap",
      overflow: "hidden",
    },
    icon: {
      mr: "8px",
    },
    action: {
      fontSize: "18px",
      fontWeight: "semibold",
      textDecoration: "none",
      mx: "8px",
      color: "inherit",
      _hover: {
        color: "inherit",
        textDecoration: "underline",
      },
      _active: {
        opacity: 0.5,
      },
    },
    closeButton: {
      ml: "8px",
      mr: "-8px",
      _active: {
        opacity: 0.5,
      },
    },
  },
  variants: {
    success: {
      container: {
        background: "primary.25",
        borderColor: "primary.600",
        color: "primary.700",
      },
    },
    warning: {
      container: {
        background: "warning.25",
        borderColor: "warning.600",
        color: "warning.700",
      },
    },
    error: {
      container: {
        background: "error.25",
        borderColor: "error.600",
        color: "error.700",
      },
    },
    info: {
      container: {
        background: "blue.25",
        borderColor: "blue.600",
        color: "blue.700",
      },
    },
    neutral: {
      container: {
        background: "gray.50",
        borderColor: "gray.600",
        color: "gray.700",
      },
    },
  },
  defaultProps: {
    variant: "neutral",
  },
  parts: ["container", "message", "button"],
};

export default ToastTheme;
